import React, { useState } from 'react'

import { Box, FormControl, FormControlLabel, RadioGroup, FormGroup, Radio, Checkbox } from '@hermes/web-components'
import BaseModal from '@components/BaseModal'
import useTranslateMessage from '@hooks/useTranslateMessage'
import { FilterData, DeliveryMethodFilterField, ConditionFilterField } from '@components/types'

import { ListContainer, ListItemContainer, ModalButton, Label } from './FilterModal.styles'

interface Props {
  title: string
  data: FilterData
  isOpen: boolean
  onClose: () => void
  onSubmit: (sortData: FilterData) => void
}

const FilterModal = ({ data, title, isOpen, onClose, onSubmit }: Props) => {
  const { t } = useTranslateMessage()
  const [localData, setLocalData] = useState<FilterData>(data)
  const [hasChanged, setHasChanged] = useState(false)

  const activeDeliveryFilter = localData.DELIVERY_METHOD.options.find(({ active }) => active)

  const handleSubmit = () => {
    if (hasChanged) {
      onSubmit(localData)
    } else {
      onClose()
    }
  }

  const onDeliveryMethodChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const val = (event.target as HTMLInputElement).value
    const newOptions = [] as DeliveryMethodFilterField[]

    // Mutually exclusive
    localData.DELIVERY_METHOD.options.forEach((o) => {
      const newObject = o
      newObject.active = val === o.type
      newOptions.push(o)
    })
    localData.DELIVERY_METHOD.options = newOptions

    setHasChanged(true)
    setLocalData(localData)
  }

  const onConditionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const val = (event.target as HTMLInputElement).value
    const newOptions = [] as ConditionFilterField[]

    localData.CONDITION.options.forEach((o) => {
      const newObject = o

      if (o.type === val) {
        newObject.active = !o.active
      }
      newOptions.push(o)
    })
    localData.CONDITION.options = newOptions

    setHasChanged(true)
    setLocalData(localData)
  }

  return (
    <BaseModal isOpen={isOpen} width={423} onClose={onClose} title={title}>
      <Box padding="0 16px 12px 16px" display="flex" flexDirection="column">
        <Box display="flex">
          <FormControl onChange={onDeliveryMethodChange} fullWidth={true}>
            <Label>{localData.DELIVERY_METHOD.title}</Label>
            <RadioGroup
              name="filter-delivery-options"
              aria-labelledby="Filter delivery options"
              defaultValue={activeDeliveryFilter?.type}
            >
              <ListContainer>
                {localData.DELIVERY_METHOD.options.map(({ label, type }) => (
                  <ListItemContainer key={type}>
                    <FormControlLabel label={label} value={type} control={<Radio style={{ padding: '9px' }} />} />
                  </ListItemContainer>
                ))}
              </ListContainer>
            </RadioGroup>
          </FormControl>
        </Box>
        <Box display="flex">
          <FormControl onChange={onConditionChange} fullWidth={true}>
            <Label>{localData.CONDITION.title}</Label>
            <FormGroup aria-labelledby="Filter book condition options">
              <ListContainer>
                {localData.CONDITION.options.map(({ label, type, active }) => (
                  <ListItemContainer key={type}>
                    <FormControlLabel label={label} value={type} control={<Checkbox defaultChecked={active} />} />
                  </ListItemContainer>
                ))}
              </ListContainer>
            </FormGroup>
          </FormControl>
        </Box>
      </Box>
      <ModalButton disabled={!hasChanged} onClick={handleSubmit}>
        {t({ id: 'common.apply', defaultMessage: 'Apply' })}
      </ModalButton>
    </BaseModal>
  )
}

export default FilterModal
